<template>
  <div class="imgsetting">
    <div :class="effect?'effect-show':''" class="control-item-animation">
      <div v-for="(item,index) in exerciseTypes" :key="index" :class="item.id == i ?'a':''" class="control-item-view"
           @click="setchatoon(item.id)">{{item.name}}
      </div>
    </div>
    <div class="imgsetting-tab">
      <div class="control-item" @click="replace">
        <div class="control-item-icon">
          <text class="icon iconfont icon-yemian"></text>
        </div>
        <div class="control-item-title">
          添加
        </div>
      </div>
      <div class="control-item" @click="effectSwitch">
        <div class="control-item-icon">
          <text class="icon iconfont icon-tupian"></text>
        </div>
        <div class="control-item-title">
          切换效果
        </div>
      </div>
      <div class="control-item" @click="fullscreen">
        <div class="control-item-title">
          全屏
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import { mapState } from 'vuex'

  export default {
    data() {
      return {
        effect: false,
        period: false,
        i: '1',
        exerciseTypes: [
          {
            'id': '1',
            'name': '默认效果',
          },
          {
            'id': '2',
            'name': '右到左',
          },
          {
            'id': '3',
            'name': '左到右',
          },
          {
            'id': '4',
            'name': '上到下',
          },
          {
            'id': '5',
            'name': '下到上',
          },
          {
            'id': '6',
            'name': '手风琴挤压',
          },
          {
            'id': '7',
            'name': '放大渐变',
          },
          {
            'id': '8',
            'name': '缩小渐变',
          },
          {
            'id': '9',
            'name': '3D旋转进',
          },
          {
            'id': '10',
            'name': '3D旋转出',
          },
          {
            'id': '11',
            'name': '景深渐变',
          },
          {
            'id': '12',
            'name': '左右旋转',
          },
          {
            'id': '13',
            'name': '上下旋转',
          },
          {
            'id': '14',
            'name': '逆时针旋转',
          },
          {
            'id': '15',
            'name': '顺时针旋转',
          },
          {
            'id': '16',
            'name': '上下缩放',
          },
          {
            'id': '17',
            'name': '3D画框效果',
          },
          {
            'id': '18',
            'name': '缩放渐变',
          }, {
            'id': '19',
            'name': '放大消隐动画',
          }, {
            'id': '20',
            'name': '透明渐变',
          }, {
            'id': '21',
            'name': '渐变缩放',
          },
        ],
      }
    },
    mounted() {

    },
    methods: {
      effectSwitch() {
        this.effect = !this.effect
        this.period = false
        this.componentsList[this.controlIndex].mpList.map(res => {
          this.i = parseInt(res.cartoon)
        })
      },
      setchatoon(val) {
        this.i = val
        this.componentsList[this.controlIndex].mpList.map(res => {
          res.cartoon = val
        })
        this.effect = false
      },
      replace() {
        this.$emit('addimg')
      },
      fullscreen() {
        this.$emit('fullscreen')
      },
    },
    computed: {
      ...mapState({
        controlIndex: state => state.controlIndex,
        componentsList: state => state.componentsList,
      }),
    },
  }
</script>

<style lang="scss">
  @import "../../public/static/css/app";


  .imgsetting {
    border-top: 1px solid $uni-text-color-placeholder;

    .imgsetting-tab {
      display: flex;
      width: 100%;
      height: 50px;
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 30;
      background: #FFFFFF;

      .control-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 50px;

        .control-item-title {
          font-size: 14px;

        }

        .control-item-icon {
        }
      }
    }

    .control-item-animation {
      position: fixed;
      width: 100%;
      bottom: -100px;
      left: 0;
      height: 50px;
      background: $uni-border-bottom-color;
      z-index: 5;
      transition: bottom 1s;
      overflow: auto;
      display: flex;
      align-items: center;
      padding: 0 10px;

      .a {
        background: #ff0000 !important;
        border-radius: 5px;
        padding: 5px 15px;
      }

      .control-item-view {
        height: 25px;
        line-height: 25px;
        min-width: 100px;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-left: 2 upx solid $uni-text-color-placeholder;
        color: $uni-text-color-inverse;
      }

      .control-item-view:nth-of-type(1) {
        border-left: none;
      }


    }

    .effect-show {
      bottom: 50px;
    }

  }


</style>
